import React from 'react';

function Demo() {
    return (
        <div style={{ textAlign: 'center', margin: '50px' }}>
            <h2>Travel Orb Demo</h2>
            <p>Watch the demo video to explore the features and insights of Travel Orb.</p>
            <iframe
                src="https://www.youtube.com/embed/KMuy8hWwoe0"
                title="Travel Orb Demo"
                width="560"
                height="315"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            ></iframe>
        </div>
    );
}

export default Demo;